
export default function Ethereum() {
  return (
    <>
      <section className="text-gray-600 body-font text">
        <div className="px-5 py-24 mx-auto flex flex-wrap">
          <h1 className="text-2xl text-center font-bold leading-tight text-white sm:text-2xl lg:text-4xl">
            Ethereum Programming Language
          </h1>

          <div className="flex flex-wrap w-full">
            <div className="lg:w-3/5 md:w-1/2 md:pr-10 md:py-6">
              <div className="flex relative pb-12">
                <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                  <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
                </div>

                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-500 inline-flex items-center justify-center text-white relative z-10">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
                  </svg>
                </div>

                <div className="flex-grow pl-4">
                  <h2 className="font-bold title-font capitalize text-xl text-white mb-1 tracking-wider">
                    Learning Ethereum
                  </h2>
                  <p className="leading-relaxed text-white text-justify">
                    Ethereum, as a pioneering blockchain platform, presents a complex yet rewarding learning journey for developers and enthusiasts. The official Ethereum website (ethereum.org) serves as an excellent starting point, offering comprehensive documentation, tutorials, and guides for various skill levels. To gain practical experience, engaging with Ethereum's robust development tools like Remix IDE, Truffle Suite, and Ganache is crucial. The Ethereum community, known for its openness and collaborative spirit, provides valuable support through forums such as Ethereum Stack Exchange and Reddit's r/ethereum. Participating in Ethereum conferences, hackathons, and local meetups can accelerate learning through networking and hands-on experiences. For a well-rounded understanding, it's important to explore both the technical aspects of smart contract development and the economic and governance facets of the Ethereum ecosystem. Staying updated with protocol upgrades, experimenting with decentralized applications (dApps), and following key figures in the Ethereum space can provide valuable insights into this rapidly evolving field.
                  </p>
                </div>
              </div>
              <div className="flex relative pb-12">
                <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                  <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
                </div>
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-500 inline-flex items-center justify-center text-white relative z-10">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 18v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1m18-2H3a2 2 0 00-2 2v4a2 2 0 002 2h18a2 2 0 002-2v-4a2 2 0 00-2-2zM6 12v-2a2 2 0 012-2h8a2 2 0 012 2v2"></path>
                  </svg>
                </div>
                <div className="flex-grow pl-4">
                  <h2 className="font-bold title-font capitalize text-xl text-white mb-1 tracking-wider">
                    Unique Features:
                  </h2>
                  <p className="leading-relaxed text-white text-justify">
                    Ethereum stands out as a pioneering blockchain platform, offering a comprehensive ecosystem for decentralized application (DApp) development and cryptocurrency transactions. Its innovative design centers around the concept of a global, decentralized computer capable of executing smart contracts. Ethereum's native programming language, Solidity, enables developers to create complex, self-executing contracts that operate on the Ethereum Virtual Machine (EVM). This architecture ensures that applications run exactly as programmed without any possibility of downtime, censorship, or third-party interference. Ethereum's robust network of nodes maintains the integrity and security of the blockchain, while its native cryptocurrency, Ether, facilitates transactions and computational processes. With features like decentralized finance (DeFi) protocols, non-fungible tokens (NFTs), and decentralized autonomous organizations (DAOs), Ethereum continues to drive innovation in the blockchain space. Its ongoing evolution, including the transition to Ethereum 2.0, aims to address scalability and energy efficiency, further solidifying its position as a leading platform in the rapidly advancing world of blockchain technology.
                  </p>
                </div>
              </div>
              <div className="flex relative">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-500 inline-flex items-center justify-center text-white relative z-10">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                </div>
                <div className="flex-grow pl-4">
                  <h2 className="font-bold title-font text-xl text-white mb-1 tracking-wider">
                    Growing Ecosystem and Industry Adoption:
                  </h2>
                  <p className="leading-relaxed text-white text-justify">
                    In parallel with the explosive growth of blockchain technology, Ethereum's ecosystem has experienced remarkable expansion. A vast array of tools, frameworks, and decentralized applications (DApps) have emerged, enabling developers to create sophisticated and diverse blockchain-based solutions. Notably, Ethereum has become the foundation for major innovations in decentralized finance (DeFi), non-fungible tokens (NFTs), and decentralized autonomous organizations (DAOs), revolutionizing traditional financial systems and digital ownership concepts. The platform's flexibility has attracted numerous projects and enterprises, from startups to Fortune 500 companies, all leveraging Ethereum's robust smart contract capabilities. Ethereum's influence extends beyond its own blockchain, inspiring and integrating with various Layer 2 solutions and sidechains to address scalability challenges. The vibrant Ethereum community, characterized by active developer forums, educational resources, and open-source collaborations, continues to drive innovation and adoption. This thriving ecosystem and widespread developer enthusiasm underscore Ethereum's crucial role in shaping the future of decentralized technologies and blockchain-based applications.
                  </p>
                </div>
              </div>
            </div>
            <img
              className="lg:w-2/5 md:w-1/2 object-contain object-center rounded-lg md:mt-0 mt-12"
              src="https://ethereum.org/_next/image/?url=%2F_next%2Fstatic%2Fmedia%2Fethereum-logo-landscape-purple-white.b26cd535.png&w=1920&q=75"
              alt="Ethereum"
            />
          </div>
        </div>
      </section>

      <section>
        <div className="px-5 py-0 mx-auto">
          <div className="flex flex-col text-left w-full mb-10">
            <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-white">
              Some Important Links
            </h1>
            <p className="w-full text-left mx-auto leading-relaxed text-base">
              These provide the overview of Ethereum's main features and tools.
            </p>
          </div>
          <div className="flex flex-wrap -m-2">
            {Rustrss.map((tools) => (
              <div key={tools.title} className="p-2 lg:w-1/3 md:w-1/2 w-full">
                <div className="h-full flex items-center border-gray-200 border p-4 rounded-lg">
                  <img alt="tools" className="w-16 h-16 bg-gray-100 object-contain object-center flex-shrink-0 rounded-full mr-4" src={tools.image} />
                  <div className="flex-grow">

                    <h2 className="text-white title-font font-bold underline text-xl">
                      {tools.title}
                    </h2>

                    <p className="text-white">
                      {typeof tools.description === 'object' ? (
                        <>
                          {tools.description.docLink && (
                            <>
                              <br />
                              <a href={tools.description.docLink} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">Official Documentation: </a> {tools.description.textDoc}
                            </>
                          )}

                          {tools.description.subredditLink && (
                            <>
                              <br />
                              <a href={tools.description.subredditLink} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">Ethereum subreddit: </a> {tools.description.text}
                            </>
                          )}
                          {tools.description.userForumLink && (
                            <>
                              <br />
                              <a href={tools.description.userForumLink} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">Users Forum: </a> {tools.description.text1}
                            </>
                          )}
                          {tools.description.czLink && (
                            <>
                              <br />
                              <a href={tools.description.czLink} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">Learn Hub </a> {tools.description.textcz}
                            </>
                          )}
                          {tools.description.ytLink && (
                            <>
                              <br />
                              <a href={tools.description.ytLink} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline">Youtube:</a> {tools.description.textyt}
                            </>
                          )}
                        </>
                      ) : (
                        tools.description
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}


          </div>
        </div>
      </section>
    </>
  );
}


const Rustrss = [
  {
    title: 'Official Documentation',
    image: "https://imgs.search.brave.com/Cg-OvJ59KzgpPmIFJMUg6zjynEJQBH_FWVCUcg25wLQ/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9jcnlwdG8tZXRo/ZXJldW0tZXRoXzk5/NDAyMy0xMDYwMzcu/anBnP3NpemU9NjI2/JmV4dD1qcGc",
    description: {
      textDoc: 'Ethereum is a decentralized, open-source blockchain platform enabling smart contracts and decentralized applications (DApps).',
      docLink: "https://ethereum.org/en/developers/docs/"
    },
  },
  {
    title: 'Community Resources',
    image: "https://imgs.search.brave.com/QhrD9SAhn4NvoBd8AfM0-8WFk5p0qhz1zXYT-FCpSo4/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9pbnZlc3QtZXRo/ZXJldW0tZXRoLWNy/eXB0by1jdXJyZW5j/eS1ncm93dGgtdXAt/Y29uY2VwdC1waG90/b181MjY5MzQtMTQz/My5qcGc_c2l6ZT02/MjYmZXh0PWpwZw",
    description: {
      text: 'A community forum for discussing Ethereum-related topics, sharing projects, and seeking help.',
      text1: 'An official forum for Ethereum users to ask questions and share knowledge.',
      subredditLink: 'https://www.reddit.com/r/ethereum/',
      userForumLink: 'https://ethereum.stackexchange.com/questions/ask'
    },

  },
  {
    title: 'Learning Resources ',
    image: 'https://ethereum.org/_next/image/?url=%2F_next%2Fstatic%2Fmedia%2Fhero.94a1ecc4.png&w=1920&q=75',
    description: {
      czLink: 'https://ethereum.org/en/learn/',
      ytLink: 'hhttps://www.youtube.com/playlist?list=PL6gx4Cwl9DGBrtymuJUiv9Lq5CAYpN8Gl',
      textcz: 'Your educational guide to the world of Ethereum. Learn how Ethereum works and how to connect to it.',
      textyt: 'You can also learn it from thenewboston, a great instructor! 🚀🔗',
    },
  },
];
